import {
  Icon,
  IconButton,
  InputAdornment,
  Tooltip
} from "@material-ui/core"
import { KeyboardDatePicker } from "@material-ui/pickers"
import { FIELDS } from "lib"
import { TypeReportReceived } from "lib/enums/reportType.enum"
import React from "react"
import { IDocumentReceivedReportParams } from "types"

type ParamsType = "year-month" | "state-types-documentDate-receptionDate"

interface Props {
  type: ParamsType | string
  disabled: boolean
  reportKey: string
  onChange: (key: string, value: any) => void
  params: IDocumentReceivedReportParams
}

const mediumInputStyle = { width: "49%" }

const ReportReceivedParams = (props: Props) => {
  const { type, disabled, params, reportKey, onChange } = props

  return (
    <div className="w-full flex flex-wrap pt-4">
      {type === TypeReportReceived.SIMPLE && (
        <React.Fragment>
          <div
            className="flex justify-between mb-2 flex items-start"
            style={{ ...mediumInputStyle, width: "100%" }}
          >
            <KeyboardDatePicker
              value={params.simple.documentStart}
              helperText={FIELDS.documentDate.name}
              FormHelperTextProps={{ style: { margin: 0 } }}
              onChange={(date) => {
                onChange(reportKey, { ...params.simple, documentStart: date })
              }}
              style={{ ...mediumInputStyle, marginTop: 0, marginRight: 10 }}
              emptyLabel={FIELDS.emptyDate.name}
              inputVariant="outlined"
              fullWidth
              invalidDateMessage={"Fecha inválida"}
              disabled={disabled}
              size="small"
              label={FIELDS.startDate.name}
              variant="inline"
              format="dd/MM/yyyy"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Icon fontSize="small" color="action">
                      event
                    </Icon>
                  </InputAdornment>
                ),
              }}
              onBlur={() => {
                if (
                  !params.simple.documentStart ||
                  isNaN(params.simple.documentStart.getTime())
                ) {
                  onChange(reportKey, {
                    ...params.simple,
                    documentStart: new Date(),
                  })
                }
              }}
            />
            <KeyboardDatePicker
              value={params.simple.documentEnd}
              onChange={(date) => {
                onChange(reportKey, { ...params.simple, documentEnd: date })
              }}
              style={{ ...mediumInputStyle, marginTop: 0 }}
              emptyLabel={FIELDS.emptyDate.name}
              inputVariant="outlined"
              fullWidth
              invalidDateMessage={"Fecha inválida"}
              disabled={disabled}
              size="small"
              label={FIELDS.endDate.name}
              variant="inline"
              format="dd/MM/yyyy"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Icon fontSize="small" color="action">
                      event
                    </Icon>
                  </InputAdornment>
                ),
              }}
              onBlur={() => {
                if (
                  !params.simple.documentEnd ||
                  isNaN(params.simple.documentEnd.getTime())
                ) {
                  onChange(reportKey, {
                    ...params.simple,
                    documentEnd: new Date(),
                  })
                }
              }}
            />
            <Tooltip arrow title={"Reiniciar fechas"}>
              <IconButton
                onClick={() => {
                  onChange(reportKey, {
                    ...params.simple,
                    documentEnd: new Date(),
                    documentStart: new Date(),
                  })
                }}
              >
                <Icon fontSize="small">{"clear_all"}</Icon>
              </IconButton>
            </Tooltip>
          </div>
        </React.Fragment>
      )}

      {type === TypeReportReceived.CONTABILIZACION && (
        <React.Fragment>
          <div
            className="flex justify-between mb-2 flex items-start"
            style={{ ...mediumInputStyle, width: "100%" }}
          >
            <KeyboardDatePicker
              value={params.accounting.documentStart}
              helperText={FIELDS.documentDate.name}
              FormHelperTextProps={{ style: { margin: 0 } }}
              onChange={(date) => {
                onChange(reportKey, { ...params.accounting, documentStart: date })
              }}
              style={{ ...mediumInputStyle, marginTop: 0, marginRight: 10 }}
              emptyLabel={FIELDS.emptyDate.name}
              inputVariant="outlined"
              fullWidth
              invalidDateMessage={"Fecha inválida"}
              disabled={disabled}
              size="small"
              label={FIELDS.startDate.name}
              variant="inline"
              format="dd/MM/yyyy"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Icon fontSize="small" color="action">
                      event
                    </Icon>
                  </InputAdornment>
                ),
              }}
              onBlur={() => {
                if (
                  !params.accounting.documentStart ||
                  isNaN(params.accounting.documentStart.getTime())
                ) {
                  onChange(reportKey, {
                    ...params.accounting,
                    documentStart: new Date(),
                  })
                }
              }}
            />
            <KeyboardDatePicker
              value={params.accounting.documentEnd}
              onChange={(date) => {
                onChange(reportKey, { ...params.accounting, documentEnd: date })
              }}
              style={{ ...mediumInputStyle, marginTop: 0 }}
              emptyLabel={FIELDS.emptyDate.name}
              inputVariant="outlined"
              fullWidth
              invalidDateMessage={"Fecha inválida"}
              disabled={disabled}
              size="small"
              label={FIELDS.endDate.name}
              variant="inline"
              format="dd/MM/yyyy"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Icon fontSize="small" color="action">
                      event
                    </Icon>
                  </InputAdornment>
                ),
              }}
              onBlur={() => {
                if (
                  !params.accounting.documentEnd ||
                  isNaN(params.accounting.documentEnd.getTime())
                ) {
                  onChange(reportKey, {
                    ...params.accounting,
                    documentEnd: new Date(),
                  })
                }
              }}
            />
            <Tooltip arrow title={"Reiniciar fechas"}>
              <IconButton
                onClick={() => {
                  onChange(reportKey, {
                    ...params.accounting,
                    documentEnd: new Date(),
                    documentStart: new Date(),
                  })
                }}
              >
                <Icon fontSize="small">{"clear_all"}</Icon>
              </IconButton>
            </Tooltip>
          </div>
        </React.Fragment>
      )}
    </div>
  )
}

export default ReportReceivedParams
